import { useState } from "react";
import "./dc-router.css";
import { PromptPair } from "../../wazawan/Wazawan";
import { DCPreviewEmployeeRecord } from "./DCPreviewEmployeeRecord";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { DCEmployeeRecord } from "./DCEmployeeRecord";
import { DCAsset } from "./DCAsset";
import { DCReporting } from "./DCReporting";

export const NR_DELETE_THIS_EMPLOYEE_RECORD_ID = "dbb8a0bf-509c-491c-9d20-ce5961515405";

type DCRouterProps = {
    promptPair: PromptPair;
    onClose: () => void;
    onSubmit: () => void;
    onCancel: () => void;
}

export const DCRouter = ({
    promptPair,
    onClose,
    onSubmit,
    onCancel
    } : DCRouterProps) => {
    const storeUser = useSelector(selectUser);

    let response : any = {};
    try {
        response = JSON.parse(promptPair.response);
    } catch (e) {
        response = promptPair.response;
    }

    // const response = JSON.parse(promptPair.response);
    const questionType = response.questionType || "";
    const object = response.object || "reporting";

    console.log("[DCRouter] promptPair.response: ", promptPair.response);
    console.log("[DCRouter] object: ", object);

    
    return (
        <div 
            className="dc-router"
        >
            {(()=> {
                switch(questionType ? questionType : object) {
                    case "employee-record":
                    case "ui":
                        return (
                            <DCEmployeeRecord 
                                id={NR_DELETE_THIS_EMPLOYEE_RECORD_ID}
                                // properties={[response.label]}
                                properties={[]}
                                onCancel={onCancel}
                                onSubmit={onSubmit}
                            /> 
                        )
                    case "asset":
                    case "form-fill":
                        return (
                            <DCAsset 
                                title={response.title || response.fileName}
                                url={response.cloudURL}
                                onCancel={onCancel}
                                onSubmit={onSubmit}
                            />
                        )
                    case "reporting":
                        return (
                            <DCReporting 
                                data={response.data}
                                isPreview={false}
                                onCancel={onCancel}
                                onSubmit={onSubmit}
                            />
                        )
                    default:
                        return (
                            <>
                                {promptPair.response}
                            </>
                        )
                }
                })()
            }   
           
        
        </div>
    )
}